import { render } from "./MyHomepage.vue?vue&type=template&id=2ce8fc97"
import script from "./MyHomepage.vue?vue&type=script&lang=js"
export * from "./MyHomepage.vue?vue&type=script&lang=js"

import "./MyHomepage.vue?vue&type=style&index=0&id=2ce8fc97&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__